/**
 * 路由路径常量集中定义。修改路由时只改这里，避免硬编码字符串散落各处。
 *
 * 仅收录在代码中被 navigate/Link/handleNavigate 跳转的路径，
 * 不带参数的路径直接给字符串；带参数的提供工厂函数。
 */

export const Paths = {
  LOGIN: '/login',
  HOME: '/',
  CRM_OVERVIEW: '/crm/overview',
  CONTACTS: '/contacts',
  COMPANIES: '/companies',
  OPPORTUNITIES: '/opportunities',
  PRODUCTS: '/products',
  PROJECTS: '/projects',
  PROJECTS_OVERVIEW: '/projects/overview',
  CONTRACTS: '/contracts',
  ITEMS: '/items',
  ITEMS_CATALOG: '/items/catalog',
  ITEMS_MY_REQUISITIONS: '/items/my-requisitions',
  APPROVALS: '/approvals',
  APPROVALS_SUBMIT: '/approvals/submit',
  APPROVALS_CONFIG: '/approvals/config',
  FINANCE_OVERVIEW: '/finance/overview',
  FINANCE_PURCHASE_PAYMENT: '/finance/purchase-payment',
  FINANCE_REIMBURSEMENT: '/finance/reimbursement',
  FINANCE_PAYROLL: '/finance/payroll',
  FINANCE_BILL_POOL: '/finance/bill-pool',
  FINANCE_INVOICE_POOL: '/finance/invoice-pool',
  FINANCE_COST_TRANSFER: '/finance/cost-transfer',
  FINANCE_DIRECT_ENTRIES: '/finance/direct-entries',
  FINANCE_LOANS: '/finance/loans',
  FINANCE_LOAN_DETAIL: '/finance/loans/detail',
  FINANCE_LOAN_PLAN: '/finance/loan-plan',
  FINANCE_CURRENT_ACCOUNTS: '/finance/current-accounts',
  FINANCE_BUDGET: '/finance/budget',
  LLM_MODELS: '/llm/models',
  LLM_SKILLS: '/llm/skills',
  LLM_TOOLS: '/llm/tools',
  AGENT_MANAGE: '/agent/manage',
  REPORTS: '/reports',
  SETTINGS: '/settings',
  SETTINGS_AI_POLICY: '/settings/ai-policy',
  SETTINGS_AI_TODOS: '/settings/ai-todos',
  USERS: '/users',
  PERMISSIONS: '/permissions',
  OPS: '/ops',
  CRON_JOBS: '/cron-jobs',
  SUPPLIERS: '/suppliers',
  PROFILE: '/profile',
  MY_REIMBURSEMENTS: '/my-reimbursements',
  MY_BUDGET: '/my-budget',
} as const;

export type Path = (typeof Paths)[keyof typeof Paths];
